import { jsx as _jsx } from "react/jsx-runtime";
import { useEngageTable } from './table/use-table';
import { EngageCampaignListView } from './list-view';
import { useBreakpoints } from '../../../../infra/dls/hooks/use-get-breakpoints';
import { useNavigate } from '../../../../infra/routing';
import { BannerType } from '../../banners';
import { useSetupEngageBanner } from '../../banners/hooks/use-setup-engage-banner';
export var EngageCampaignListContainer = function () {
    var _a = useEngageTable(), table = _a.table, isLoading = _a.isLoading, emptyTableState = _a.emptyTableState, onRowClick = _a.onRowClick, filters = _a.filters, sort = _a.sort, pagination = _a.pagination, count = _a.count;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var navigate = useNavigate();
    useSetupEngageBanner({
        bannerType: BannerType.AutomatedCampaign,
        // TODO: Should implement an actual redirect to automation flow, once available
        onPrimaryClick: function () { return navigate('/engagement-v2/new/type'); },
    });
    return (_jsx(EngageCampaignListView, { table: table, isLoading: isLoading, emptyTableState: emptyTableState, onRowClick: onRowClick, filters: filters, sort: sort, count: count, pagination: pagination, mobileView: isMobileOrSmaller }));
};
